var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "-4 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vivid.JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vivid-Icons",
    transform: "translate(-125.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(37.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-marker",
    transform: "translate(78.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z",
    id: "Shape",
    fill: "#FF6E6E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#0C0058",
    fillRule: "nonzero",
    cx: 14,
    cy: 14,
    r: 7
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.b0c8f45defb6e2c8893b773ca88b9d91.svg";
export { ForwardRef as ReactComponent };